// extracted by mini-css-extract-plugin
export default {"wrapperPopUp":"CustomDropdown_wrapperPopUp__J7b1Y"};